import * as yup from 'yup';
import { useMemo } from 'react';

const signersArray = yup
  .array()
  .of(
    yup.object().shape({
      firstName: yup.string().required('A first name is required.'),
      lastName: yup.string().required('A last name is required.'),
      email: yup.string().email().nullable(),
    })
  )
  .min(1, 'At least one signer is required.');

export const useBuildSignersValidationSchema = (emailRequired?: boolean) => {
  return useMemo(() => {
    if (!emailRequired) {
      return yup.object().shape({
        signers: signersArray,
      });
    }
    return yup.object().shape({
      signers: signersArray.test('at least one email', 'At least one signer with an email is required.', (signers) => {
        return !!signers?.some((signer) => !!signer.email);
      }),
    });
  }, [emailRequired]);
};
